
export enum ConceptValueDataType {
	Check = 'check',
	Checks = 'checks',
	Date = 'date',
	Decimal = 'decimal',
	Integer = 'integer',
	// stringified JSON
	JSON = 'json',
	// literal javascript object/array
	Object = 'object',
	Radios = 'radios',
	Select = 'select',
	String = 'string',
	File = 'file',
}

export const typeHasSubconcepts = (valueDataType: ConceptValueDataType|null) => {
	switch(valueDataType) {
		case ConceptValueDataType.Checks:
		case ConceptValueDataType.Radios:
		case ConceptValueDataType.Select:
			return true
	}
	return false
}
